import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ButtonComponent, InputComponent, LoaderComponent } from '@dnhb/node_package';
import { dispatchMapper } from '../../../shared/wizard/actions';
import { shapeSettings, shapeOutput, shapeInput } from '../config';

class LeadFormComponent extends Component {
  render() {
    const {
      input,
      sync,
      output,
      settings,
      onSubmit,
      syncing,
    } = this.props;
    const { errors } = output;

    const leadAddressInformation = settings?.leadAddressInformation ?? false;

    return (
      <form
        onSubmit={onSubmit}
        key="leadForm"
      >
        <div className="form-wrapper">
          <div className="row">
            <div className="group col-xs-12">
              <h2>{settings.leadFormHeader || ''}</h2>
              <p>{settings.leadFormText || ''}</p>
            </div>
          </div>
          <div className="row">
            <div className="group col-md-7 col-xs-12">
              <InputComponent
                id="first_name"
                label="Voornaam"
                name="first_name"
                value={input.first_name}
                onChangeHandler={sync('first_name')}
                errors={errors.first_name}
              />
            </div>
            <div className="group col-md-5 col-xs-12">
              <InputComponent
                id="last_name_prefix"
                label="Tussenvoegsel"
                name="last_name_prefix"
                value={input.last_name_prefix}
                onChangeHandler={sync('last_name_prefix')}
                errors={errors.last_name_prefix}
              />
            </div>
          </div>

          <div className="row">
            <div className="group col-md-12 col-xs-12">
              <InputComponent
                id="last_name"
                label="Achternaam"
                name="last_name"
                value={input.last_name}
                onChangeHandler={sync('last_name')}
                errors={errors.last_name}
              />
            </div>
          </div>

          <div className="row">
            <div className="group col-md-12 col-xs-12">
              <InputComponent
                id="email"
                label="E-mailadres"
                name="email"
                value={input.email}
                onChangeHandler={sync('email')}
                errors={errors.email}
              />
            </div>
          </div>

          <div className="row">
            <div className="group col-md-12 col-xs-12">
              <InputComponent
                id="phone_number"
                label="Telefoonnummer"
                name="phone_number"
                value={input.phone_number}
                onChangeHandler={sync('phone_number')}
                errors={errors.phone_number}
              />
            </div>
          </div>
          {leadAddressInformation ? (
              <>
                <div className="row">
                  <div className="group col-md-12 col-xs-12">
                    <InputComponent
                        id="postal_code"
                        label="Postcode"
                        name="postal_code"
                        value={input.postal_code}
                        onChangeHandler={sync('postal_code')}
                        errors={errors.postal_code}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="group col-md-12 col-xs-12">
                    <InputComponent
                        id="house_number"
                        label="Huisnummer"
                        name="house_number"
                        value={input.house_number}
                        onChangeHandler={sync('house_number')}
                        errors={errors.house_number}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="group col-md-12 col-xs-12">
                    <InputComponent
                        id="house_number_addition"
                        label="Toevoeging"
                        name="house_number_addition"
                        value={input.house_number_addition}
                        onChangeHandler={sync('house_number_addition')}
                        errors={errors.house_number_addition}
                    />
                  </div>
                </div>
              </>
          ) : (<></>)}
        </div>
        <div className="row lead-buttons input">
          <ButtonComponent
            value="Annuleren"
            name="cancel"
            id="cancel"
            label=""
            className="group col-xs-12 col-md-6"
            inputClassNames="rounded secondary"
            showLabel={false}
            onClickHandler={this.props.onAbort}
          />
          <div className="group col-xs-12 col-md-6">
            {
              syncing ?
                <span className="rounded short">
                  <LoaderComponent show />
                </span> : <input className="rounded" type="submit" value="Verzenden" />
            }
          </div>
        </div>
      </form>
    );
  }
}

LeadFormComponent.propTypes = {
  settings: shapeSettings.isRequired,
  output: shapeOutput.isRequired,
  input: shapeInput.isRequired,
  sync: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onAbort: PropTypes.func.isRequired,
  syncing: PropTypes.bool.isRequired,
};

LeadFormComponent.defaultProps = {};

export default connect(state => ({
  settings: state.settings,
  syncing: state.syncing,
  output: state.output,
  input: state.input,
}), dispatchMapper)(LeadFormComponent);
